export const UPDATE_USER_ASSET = "updateUserAsset"
export const UPDATE_USER_INFO = "updateUserInfo"
export const UPDATE_USER_ACTIONS = "updateUserAction"
export const UPDATE_USER_JOURNALS = "updateUserJournal"